import { Box } from "@mui/material";
import { TopToolbar, usePermissions } from "react-admin";
import CustomExportButton from "../unit/CustomExportButton";
import CustomFilterButton from "../unit/CustomFilterButton";
import BankerAdd from "./BankerAdd";
const BankerListActions = () => {
  const { permissions } = usePermissions();
  return (
    <>
      <TopToolbar sx={{ width: "100%" }}>
        <Box sx={{ textAlign: "right", width: "100%", display: "" }}>
          <BankerAdd />
        </Box>
        {/* <CustomFilterButton /> */}
        <CustomExportButton />
      </TopToolbar>
    </>
  );
};

export default BankerListActions;
